const closeCallWindowWaitKey = 'wait:'

export function getCloseCallWindowValue (wait) {
  if (wait) return `${closeCallWindowWaitKey}${wait}`
  return 'true'
}

export function getCloseCallWindowWaitSec (value) {
  if (value && value.startsWith(closeCallWindowWaitKey)) {
    const v = Number(value.replace(/[^0-9]/g, ''))
    if (!isNaN(v)) return v
  }
  return 0
}
